<template>
    <div :style="$props.isImg ? 'background: black' : ''" :class="show ? 'error-msg-wrap' : 'hide'" style="width:100%">
        <div style="position:relative;width:98%;height:100%">
            <div v-if="downloadString" class="pdf-pop-link">
                <a :href="pdfURL" target="_blank" :download="downloadString">Open in new tab</a>
            </div>
            <svg @click="close()" class="remove-filter" style="background:black;border-radius:50%;width:auto;fill:white;top:-5px;right:-5px;height:32px" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6 16.094l-4.157-4.104 4.1-4.141-1.849-1.849-4.105 4.159-4.156-4.102-1.833 1.834 4.161 4.12-4.104 4.157 1.834 1.832 4.118-4.159 4.143 4.102 1.848-1.849z"></path></svg>
            <div style="width:100%;height:100%">
                <iframe style="width:100%;height:100%" :src="pdfURL" />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import axios from 'axios';
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'PdfPopUp',
    props: ['url', 'isImg'],
    data() {
        return {
            pdfURL: '',
            downloadString: new Date().getTime().toString(36) as any,
            show: false
        }
    },
    created() {
        this.pdfURL = this.$props.url;
        if(!this.pdfURL.includes('.pdf')) {
            this.downloadString = null;
        }
        this.show = true;
    },
    methods: {
        close() {
            this.$emit('close');
        }
    }
})
</script>